import { render, staticRenderFns } from "./ContabilitaDocumentoDatiDocumentoModalComponent.vue?vue&type=template&id=85bea7da"
import script from "./ContabilitaDocumentoDatiDocumentoModalComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoDatiDocumentoModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports